import { formatIDR, splitColors, splitSizes } from "../data/products";
import { ShoppingBag } from "lucide-react";

const ProductCard = ({ product, onOpen, idx = 0, prefix = "" }) => {
  const sizes = splitSizes(product.sizes);
  const colorsAll = splitColors(product.colors);
  const otherIdx = colorsAll.findIndex((c) =>
    c.toLowerCase().includes("other colors")
  );
  const colors = otherIdx >= 0 ? colorsAll.slice(0, otherIdx) : colorsAll;
  const hasOther = otherIdx >= 0;
  const tid = (suffix) =>
    prefix ? `${prefix}-${suffix}-${product.id}` : `${suffix}-${product.id}`;

  return (
    <article
      className="product-card group h-full"
      data-testid={tid("product-card")}
      style={{ animationDelay: `${idx * 60}ms` }}
    >
      <div className="img-wrap">
        <img
          src={product.image}
          alt={`Triple J Bali ${product.name}`}
          loading="lazy"
        />
        <span className="absolute top-3 left-3 badge-soft">
          {product.materialDisplay}
        </span>
        <button
          data-testid={tid("product-card-add")}
          onClick={() => onOpen(product)}
          className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 rounded-full bg-[hsl(var(--ink))] text-[hsl(var(--cream))] px-4 py-2 text-xs font-medium opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300"
        >
          <ShoppingBag className="w-3.5 h-3.5" /> Add to Bag
        </button>
      </div>
      <div className="flex items-start justify-between gap-3 mt-1">
        <div className="min-w-0">
          <h3
            className="font-display text-[17px] leading-snug line-clamp-2"
            data-testid={tid("product-card-name")}
          >
            {product.name}
          </h3>
          <p className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">
            {sizes.join(" / ")}
          </p>
        </div>
        <p
          className="font-display text-base whitespace-nowrap pt-0.5"
          data-testid={tid("product-card-price")}
        >
          {formatIDR(product.price)}
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-1.5 -mt-1">
        {colors.slice(0, 4).map((c) => (
          <span
            key={c}
            className="text-[11px] text-[hsl(var(--ink))]/65 border border-[hsl(var(--border))] rounded-full px-2 py-0.5"
          >
            {c}
          </span>
        ))}
        {hasOther && (
          <span className="text-[11px] italic text-[hsl(var(--muted-foreground))]">
            +Other colors available
          </span>
        )}
      </div>
      <button
        data-testid={tid("product-card-open")}
        onClick={() => onOpen(product)}
        className="mt-auto self-start inline-flex items-center justify-center rounded-full bg-[hsl(var(--ink))] text-[hsl(var(--cream))] px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] hover:bg-[hsl(24_18%_8%)] transition-colors"
      >
        View &amp; Order
      </button>
    </article>
  );
};

export default ProductCard;
